import { defineStore, acceptHMRUpdate } from "pinia";

type ContactInfo = {
   first_name: string;
   last_name: string;
   email: string;
   phone: string;
   is_paid: boolean;
   register_to_website: boolean;
   payment_method: string;
};

export const useContactInfoStore = defineStore("ContactInfoStore", () => {
   const contactInfo = ref<ContactInfo>({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      is_paid: false,
      register_to_website: false,
      payment_method: "",
   });
   return { contactInfo };
});

if ((import.meta as any).hot) {
   (import.meta as any).hot.accept(
      acceptHMRUpdate(useContactInfoStore, (import.meta as any).hot),
   );
}
